// Largura que a barra lateral ocupa na tela, para centralizar overlays na área de conteúdo.
// getBoundingClientRect: a barra fechada no mobile está fora da tela (right <= 0) e a aberta/recolhida no desktop dá a largura real.
export function getSidebarOffset(): number {
    const sidebar = document.getElementById('side-bar');
    return sidebar ? Math.max(0, sidebar.getBoundingClientRect().right) : 0;
}
